import { render, staticRenderFns } from "./DuplicateUserModal.vue?vue&type=template&id=32687691"
import script from "./DuplicateUserModal.vue?vue&type=script&lang=js"
export * from "./DuplicateUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports